var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2479_3952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
    fill: "#F0F0F0",
    stroke: "#DFE1E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0001C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16.0001",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73934 8.34802C9.73934 6.01689 11.3777 4.06952 13.5654 3.5917C13.2292 3.51833 12.8803 3.47852 12.5219 3.47852C9.83247 3.47852 7.65234 5.65864 7.65234 8.34808C7.65234 11.0375 9.83247 13.2176 12.5219 13.2176C12.8802 13.2176 13.2291 13.1778 13.5654 13.1044C11.3777 12.6266 9.73934 10.6792 9.73934 8.34802Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.82617L16.3454 4.88898H17.4629L16.5587 5.54592L16.9041 6.60873L16 5.95192L15.0959 6.60873L15.4412 5.54592L14.5371 4.88898H15.6546L16 3.82617Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2892 5.91309L13.6345 6.97596H14.752L13.8479 7.63284L14.1933 8.69565L13.2892 8.03884L12.3849 8.69565L12.7304 7.63284L11.8262 6.97596H12.9437L13.2892 5.91309Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7109 5.91309L19.0564 6.97596H20.1739L19.2697 7.63284L19.6151 8.69565L18.7109 8.03884L17.8068 8.69565L18.1522 7.63284L17.248 6.97596H18.3655L18.7109 5.91309Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.668 9.04395L18.0133 10.1068H19.1308L18.2267 10.7637L18.5721 11.8265L17.668 11.1697L16.7638 11.8265L17.1092 10.7637L16.2051 10.1068H17.3225L17.668 9.04395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3321 9.04395L14.6774 10.1068H15.795L14.8908 10.7637L15.2363 11.8265L14.3321 11.1697L13.4279 11.8265L13.7733 10.7637L12.8691 10.1068H13.9867L14.3321 9.04395Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2479_3952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/singapore.70a68931a99526ef370fa3d3a67ab0d5.svg";
export { ForwardRef as ReactComponent };